import type { RouterRootContext } from '@/router'
import type { UserRole } from '@/validators/auth'
import { redirect } from '@tanstack/react-router'

export function checkAuthRoleBeforeLoad(context: RouterRootContext, role: UserRole) {
  if (!context.isAuthenticated || !context.user) {
    throw redirect({ to: '/auth/login', search: { next: window.location.pathname } })
  }

  if (context.user.role !== 'admin' && context.user.role !== role) throw redirect({ to: '/' })
}
